export enum ClassTypeSelectionRow {
    Single ="single",
    Multiple = "multiple"
}